<template>
    <transition name="fade" mode="out-in">
        <div v-if="visible" class="mega-modal" @click.self="hide">
            <div class="card h-100">
                <h5 class="card-header">
                    {{ component.name }}
                    <button type="button" class="close" aria-label="Close" @click="hide">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </h5>
            
                <div v-if="loading" class="loading">
                    <fa-layer class="fa-lg fa-6x">
                        <fa :icon="['fas','cloud']" />
                        <fa :icon="['fal','arrow-down']" class="loading-icon" transform="shrink-9 right-2 down-1" style="color: white;" />
                    </fa-layer>
                </div>

                <template v-else>
                    <div class="card-body card-dashboard d-flex flex-column">
                        <div class="row flex-grow-1">
                            <div class="col-md-5 col-lg-4 d-flex flex-column">
                                <card no-title>
                                    <header slot="header">
                                        <h4>Basdata</h4>
                                    </header>
                                    <ul class="modal-list">
                                        <li>
                                            <span class="list-title">Filnamn</span> 
                                            <span class="list-def">{{ component.attachment.filename }}</span>
                                        </li>
                                        <li>
                                            <span class="list-title">Kategori</span> 
                                            <span class="list-def">{{ component.category.name }}</span>
                                        </li>
                                        <li>
                                            <span class="list-title">Skapades</span> 
                                            <span class="list-def">{{ component.created_at }}</span>
                                        </li>
                                        <li>
                                            <span class="list-title">Uppdaterades</span> 
                                            <span class="list-def">{{ component.updated_at }}</span>
                                        </li>
                                    </ul>
                                    <div v-if="canEdit" slot="footer" class="d-flex">
                                        <div class="btn-group dropup">
                                            <button :disabled="rotating" class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <template v-if="!rotating">
                                                    <fa :icon="['fas','redo']" /> Rotera
                                                </template>
                                                <template v-else>
                                                    <fa :icon="['fas','circle-notch']" spin /> Roterar..
                                                </template>
                                            </button>
                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <a class="dropdown-item pl-3" href="#" @click="doRotate(270)"><fa :icon="['fal','undo']" fixed-width class="mr-1" /> 90° motsols</a>
                                                <a class="dropdown-item pl-3" href="#" @click="doRotate(90)"><fa :icon="['fal','redo']" fixed-width class="mr-1" /> 90° medsols</a>
                                            </div>
                                        </div>
                                        
                                        <button class="btn btn-primary btn-sm ml-auto mr-2">
                                            <label class="" title="Välj fil" for="customFile">
                                                <fa :icon="['fas','circle-notch']" spin v-if="replacing" />
                                                {{ replacing ? 'Ersätter...' : 'Ersätt' }}
                                            </label>
                                            <input type="file" id="customFile" class="d-none" @change="setFile" ref="files">
                                        </button>

                                        <router-link 
                                                class="btn btn-secondary btn-sm"
                                                :to="{ path : '/components/' + component.id + '/edit' }">Redigera</router-link>
                                    </div>
                                </card>

                                <card no-title class="mt-4">
                                    <header slot="header">
                                        <h4>Används i artiklar:</h4>
                                    </header>
                                    
                                    <ul class="list-unstyled">
                                        <li class="mb-1 text-truncate" v-for="printable in component.printables" :key="printable.id">
                                            <fa :icon="['fal','file-pdf']" />
                                            <router-link 
                                                class="block"
                                                :to="{ path : '/printables/' + printable.id + '?company_id=' + printable.company_id }">{{ printable.name }}</router-link>
                                        </li>
                                    </ul>
                                    <div v-if="canEdit" slot="footer" class="text-right d-flex">
                                        <button class="btn btn-primary btn-sm mr-auto" @click="convert(component.id)">Skapa artikel</button>

                                        <router-link 
                                                class="btn btn-secondary btn-sm"
                                                :to="{ path : '/components/' + component.id + '/edit' }">Redigera</router-link>
                                    </div>
                                </card>

                                <!--<comment-form target="component" :target-id="componentId" v-on:updateComments="setComments" class="mt-4" />-->
                            </div>
                            <div class="col-md-7 col-lg-8">
                                <card no-title class="h-100 card-timeline">
                                    <header slot="header">
                                        <h4>Sidor</h4>
                                    </header>
                                    
                                    <div class="component-attachment" v-for="(page, index) in component.attachment.attachment_pages" :key="page.id" :class="{'active' : imgActive == index }">
                                        <img v-img="galleryOptions" @click="imgActive = index" class="img-fluid" :src="page.prefix + page.path + '?v=' + version" />
                                        <span class="badge badge-secondary badge-page-no">{{ page.page_number }}</span>
                                    </div>
                                    
                                </card>
                            </div>
                        </div>

                    </div>
                    <div class="card-footer d-flex">
                        
                    </div>
                </template>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios';
import store from '~/store';
import $ from 'jquery';
import swal from "sweetalert2";

import CommentForm from '~/components/CommentForm';
import Timeline from '~/components/Timeline';

export default {
    name: "componentModal",
    components:{
        CommentForm, Timeline
    },
    data(){
        return {
            loading: true,
            version: null,
            visible: false,
            newComment: null,
            imgOpen : false,
            imgActive : null,
            rotating : false,
            replacing: false,
            replaceAttachment : [],
            galleryOptions : {
                group : 'gallery',
                opened : this.imgOpened,
                closed : this.imgClosed,
                changed : this.imgChanged
            },
            component : {
                name : '',
                attachment : {
                    attachment_pages : []
                },
                category : {
                    name : ''
                }
            },
            attachment : null
        }
    },
    created(){
        if(this.componentId){
            this.fetchcomponent(this.componentId);
            this.show();
        }
        this.setVersion();
    },
    computed : {
        canEdit(){
            return store.getters['auth/user'] ? store.getters['auth/user'].role >= 3 : -1;
        },
        query(){
            return this.$route.query ? this.$route.query : false;
        }
    },
    methods: {
        setFile(ev){
            this.replace_attachment = Array.from(ev.target.files);
            this.replaceComponent();
        },
        setVersion(){
            this.version = new Date().getTime();
        },
        hide () {
            this.visible = false
            this.$emit('clear');
            this.toggleBodyClass('remove','fixed');
            this.unBindKeys();
            Object.assign(this.$data, this.$options.data.apply(this))
        },
        show () {
            this.visible = true
            this.toggleBodyClass('add','fixed');
            this.bindKeys();
        },
        imgOpened(){

        },
        imgClosed(){
            
        },
        imgChanged(index){
            this.imgActive = index;
        },
        onKeyUp(event){
            if (event.keyCode == 27 && !this.imgActive) {// Escape
                this.hide()
            }
        },
        bindKeys(){
            window.addEventListener('keyup', this.onKeyUp);
        },
        unBindKeys(){
            window.removeEventListener('keyup', this.onKeyUp);
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'add') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
        ellipsis(str) {
            if (str.length > 35) {
                return str.substr(0, 20) + '...' + str.substr(str.length-10, str.length);
            }
            return str;
        },
        color(){
            let colors = ['primary','secondary','warning','success','info','danger'];
            return 'is-' + colors[Math.floor(Math.random() * 7)]
        },
        setComments(comment){
            if(comment){
                this.newComment = comment.id;
            }

            this.$nextTick(() => {
                let el = document.querySelector('.timeline-item:last-child');
                if(el){
                    el.scrollIntoView();
                }
            })
        },
        async convert(id){
            const { data } = await axios.post('/api/component/' + this.componentId + '/directpdf');

            if(data.id){
                this.$router.push({
                    name: "printables.id",
                    query: {
                        company_id : data.company_id
                    },
                    params: {
                        id: data.id 
                    }
                });
            }
        },
        async doRotate(degrees){
            this.rotating = true;

            const { data } = await axios.post('/api/component/' + this.componentId + '/rotate',{
                degrees : degrees
            });

            this.version = Math.random();
            this.rotating = false;
        },
        async setStatus(status){
            let params = {
                status: status
            };

            const { data } = await axios.post('/api/component/' + this.componentId + '/status',params)
            this.component.status = status;
            this.setComments(data);
        },
        async fetchcomponent(id){
            const { data } = await axios.get('/api/component/' + id);
            this.component = data;
            this.loading = false;
        },
        async replaceComponent(){
            this.replacing = true;
            let formData = new FormData();
            
            if(this.replace_attachment){
                formData.append('attachment', this.replace_attachment[0]);
            }
            this.$refs.files.value = '';
            this.component.attachment.attachment_pages = [];
            this.setVersion();

            try {
                const { data } = await axios.post('/api/component/' + this.componentId + '/replace',formData);
            } catch (error) {
                swal({
                    title: 'Fel vid ersättning',
                    text: 'Komponenten du vill ersätta har fel antal sidor. Kontrollera sidantalet och försök igen.',
                    type: "error",
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: this.$t("reset"),
                    confirmButtonClass: "bg-danger",
                    cancelButtonText: this.$t("cancel")
                })
            }
            
            this.replacing = false;
            this.fetchcomponent(this.componentId);
        }
    },
    props: [
        'componentId',
        'open'
    ],
    watch: {
        componentId (newId,oldId) {
            if (this.componentId && !this.visible) this.show()
            else if (!this.componentId && this.visible) this.hide()

            if(this.componentId){
                this.fetchcomponent(this.componentId);
            }
        },
    },
}
</script>
<style lang="scss">
    
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/ComponentModal.vue